import { connectWithStore } from '@react/Common/connectWithStore';
import { ListControlsComponent } from '@react/Common/ListControls';
import { getTrackerState, searchTrackerList, toggleAllTrackers } from '@redux/ducks/tracker/tracker';
import { disableSelectedTrackers, enableSelectedTrackers } from '@redux/ducks/userPermissions/userPermissions';

const mapStateToProps = state => {
  const { trackerList, searchTerm } = getTrackerState(state);

  return {
    list: trackerList,
    isSelected: trackerList.some(tracker => tracker.selected),
    isDisabled: !trackerList.length,
    isChecked: trackerList.length > 0 && trackerList.every(partner => partner.selected),
    isFiltered: Boolean(searchTerm),
    searchTerm,
    searchName: t('label.tracker'),
    searchPlaceholder: t('label.search-trackers'),
  };
};

const mapStateToDispatch = {
  onSearch: searchTrackerList,
  disableSelected: disableSelectedTrackers,
  enableSelected: enableSelectedTrackers,
  toggleAll: toggleAllTrackers,
};

export const TrackerListControls = connectWithStore(mapStateToProps, mapStateToDispatch)(ListControlsComponent);
